import { cn, forwardRef } from "@heroui/react"
import { DetailedHTMLProps, HTMLAttributes } from "react"

type MaskProps = { showMask?: boolean } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const Mask = forwardRef(
  ({ showMask, ...props }: MaskProps,
    ref) => {
    return (
      <div
        data-show={showMask}
        className={cn(
          "w-[100vw] h-[100dvh] fixed z-[49] left-0 top-0 hidden bg-theme-black/30",
          "data-[show=true]:block",
        )}
        ref={ref}
        {...props}
      ></div>
    )
  })